import classNames from 'classnames'
import React, { useState } from 'react'

import * as classes from '../styles/slider.module.sass'

const Item = ({ content, ...props }) => <div {...props}>{content}</div>

const RadioButtonMenu = ({ name, idItem, idGroup, isChecked, setCurrent }) => (
    <label
        className={classNames(classes.chip, {
            [classes.chipActive]: isChecked,
        })}
        htmlFor={idItem}
    >
        <input
            className={classes.input}
            name={idGroup}
            type="radio"
            id={idItem}
            defaultChecked={isChecked}
            onChange={setCurrent}
        />
        {name}
    </label>
)

const Slider = ({ id = 'slider', items = [], align = 'right', className }) => {
    const [current, setCurrent] = useState(0)

    const menuClassNames = classNames(classes.menu, { [classes.left]: align === 'left' })
    return (
        <div className={className}>
            <menu className={menuClassNames}>
                {items.map(({ name }, i) => (
                    <RadioButtonMenu
                        key={i}
                        name={name}
                        idGroup={id}
                        idItem={`${id}-${i}`}
                        isChecked={i === current}
                        setCurrent={() => setCurrent(i)}
                    />
                ))}
            </menu>
            <div className={classes.wrapperItemOuter}>
                <div
                    className={classes.wrapperItemInner}
                    style={{
                        width: `${100 * items.length}%`,
                        marginLeft: `${-100 * current}%`,
                    }}
                >
                    {items.map(({ content }, i) => (
                        <Item key={i} content={content} className={classes.item} />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Slider
